import { filtrarPorNome, normalizar } from "./busca";

/* A busca por nome das listas do painel.

   Os casos abaixo são todos com dado REAL do mart de homologação, porque é a
   forma dos nomes que cria as armadilhas: as redes chegam em caixa alta e com
   acento ("FORMANDO CIDADÃOS"), as escolas trazem abreviação com ponto
   ("E. M. Antônio...") e as turmas, prefixo de série. */

describe("normalizar", () => {
  it("tira acento, caixa e espaço das pontas", () => {
    expect(normalizar("  FORMANDO CIDADÃOS ")).toBe("formando cidadaos");
    expect(normalizar("Antônio")).toBe("antonio");
    expect(normalizar("REGIÃO")).toBe("regiao");
  });

  it("aceita nulo e número sem quebrar", () => {
    expect(normalizar(null)).toBe("");
    expect(normalizar(undefined)).toBe("");
    expect(normalizar(9)).toBe("9");
  });
});

describe("filtrarPorNome", () => {
  const ESCOLAS = [
    { id: 1, escola: "E. M. ANTÔNIO PEREIRA DE ANDRADE" },
    { id: 2, escola: "COLÉGIO REFERÊNCIA" },
    { id: 3, escola: "ESCOLA MUNICIPAL DO BAIRRO" }
  ];

  it("acha sem o usuário digitar acento", () => {
    // A razão de existir da normalização: ninguém digita "Antônio" na busca.
    expect(filtrarPorNome(ESCOLAS, "antonio", ["escola"])).toEqual([
      ESCOLAS[0]
    ]);
    expect(filtrarPorNome(ESCOLAS, "colegio referencia", ["escola"])).toEqual([
      ESCOLAS[1]
    ]);
  });

  it("acha no meio do nome, não só no começo", () => {
    // Quem procura "municipal" quer "ESCOLA MUNICIPAL DO BAIRRO".
    expect(filtrarPorNome(ESCOLAS, "municipal", ["escola"])).toEqual([
      ESCOLAS[2]
    ]);
  });

  it("aceita termos soltos, na ordem que vierem", () => {
    // "antonio andrade" tem de achar "ANTÔNIO PEREIRA DE ANDRADE", que uma
    // comparação da frase inteira perderia por causa do "PEREIRA DE" no meio.
    expect(filtrarPorNome(ESCOLAS, "antonio andrade", ["escola"])).toEqual([
      ESCOLAS[0]
    ]);
    expect(filtrarPorNome(ESCOLAS, "andrade antonio", ["escola"])).toEqual([
      ESCOLAS[0]
    ]);
  });

  it("busca em mais de um campo", () => {
    const turmas = [
      { id: 1, turma: "9º B", escola: "COLÉGIO REFERÊNCIA" },
      { id: 2, turma: "1º A", escola: "ESCOLA MUNICIPAL" }
    ];

    // O professor com turmas em duas escolas procura pelos dois.
    expect(filtrarPorNome(turmas, "referencia", ["turma", "escola"])).toEqual([
      turmas[0]
    ]);
    expect(filtrarPorNome(turmas, "1º", ["turma", "escola"])).toEqual([
      turmas[1]
    ]);
  });

  it("termo vazio devolve a lista inteira", () => {
    expect(filtrarPorNome(ESCOLAS, "", ["escola"])).toHaveLength(3);
    expect(filtrarPorNome(ESCOLAS, "   ", ["escola"])).toHaveLength(3);
  });

  it("sem correspondência devolve vazio, não a lista toda", () => {
    // O erro oposto é pior que não achar: mostrar tudo dá a impressão de que a
    // busca funcionou e nada foi filtrado.
    expect(filtrarPorNome(ESCOLAS, "xyz", ["escola"])).toEqual([]);
  });

  it("lista ausente não quebra", () => {
    expect(filtrarPorNome(null, "a", ["escola"])).toEqual([]);
    expect(filtrarPorNome(undefined, "", ["escola"])).toEqual([]);
  });

  it("campo ausente na linha não quebra", () => {
    const linhas = [{ id: 1 }, { id: 2, rede: "Sucesso Digital" }];
    expect(filtrarPorNome(linhas, "sucesso", ["rede"])).toEqual([linhas[1]]);
  });

  it("as redes reais do mart, por nome parcial", () => {
    const redes = [
      { id: 80, rede: "FORMANDO CIDADÃOS" },
      { id: 92, rede: "Sucesso Digital" },
      { id: 79, rede: "Sucesso Sistema de Ensino" },
      { id: 45, rede: "Construir Digital" }
    ];

    // "sucesso" pega as duas redes com esse nome; "digital" cruza dois grupos
    // diferentes — é o tipo de busca que um ranking de clientes recebe.
    expect(filtrarPorNome(redes, "sucesso", ["rede"])).toHaveLength(2);
    expect(filtrarPorNome(redes, "digital", ["rede"])).toHaveLength(2);
    expect(filtrarPorNome(redes, "cidadaos", ["rede"])).toEqual([redes[0]]);
  });
});
